const BillingPeriods = [
    'inherit',
    'none',
    'annual',
    'bi-annual',
    'monthly'
]

export default BillingPeriods;
